<template>
	<fieldset
		class="radio"
		:class="{
			'radio--inline': inline
		}"
	>
    <legend v-if="legend">
      <span v-sanitize="legend"/>
      <span
        v-if="legendOption"
        class="optional"
        v-sanitize="legendOption"
      />
    </legend>
		<div
			v-for="(option, index) in options"
			:key="option.value"
			class="radio-area"
			:class="{
				'radio-area--block': vertical
			}"
		>
			<input
				type="radio"
				:id="`${uniqueId}-${index}-${option.value}`"
				:name="name"
				:required="required"
				:value="option.value"
				@change="onChange"
				:checked="option.value === value"
				:disabled="disabled"
			>
			<label
				:for="`${uniqueId}-${index}-${option.value}`"
				v-html="option.label"
			/>
		</div>
	</fieldset>
</template>

<script>
export default {
	props: {
		name: String,
		legend: String,
		legendOption: String,
		required: Boolean,
		value: Number | String,
		options: Array,
		vertical: Boolean,
		inline: Boolean,
		disabled: Boolean,
	},
	data() {
		return {
			uniqueId: `${this.name}-${(Date.now().toString(36) + Math.random().toString(36).substring(2, 7))}`,
		}
	},
	methods: {
		onChange(e) {
			this.$emit('input', e.target.value);
		}
	}
}
</script>

<style>

</style>
